<template>
  <div class="reset-password">
    <PopUp v-if="modalActive" :modalMessage="modalMessage" v-on:close-modal="closeModal" />
    <Loading v-if="loading" />
    <div class="form-wrap">
      <div class="background"></div>
      <form class="reset">
        <p class="back-home">
          <router-link class="router-link" :to="{ name: 'Login' }">Back to Login</router-link>
        </p>
        <h2>Reset Password</h2>
        <p>Forgot your password? Enter your email to reset it</p>
        <div class="inputs">
          <div class="input">
            <input type="text" placeholder="Email" v-model="email" />
            <email class="icon" />
          </div>
        </div>
        <button @click.prevent="resetPassword">Reset</button>
      </form>
      <div class="background"></div>
    </div>
  </div>
</template>

<script>
import email from "../assets/Icons/envelope-regular.svg";
import Loading from "../components/Loading.vue";
import firebase from "firebase/app";
import "firebase/auth";
import PopUp from "../components/PopUp.vue";
export default {
  name: "forgot-password-vue",
  mounted() {
    window.scrollTo(0, 0)
  },
  data() {
    return {
      email: null,
      modalActive: null,
      modalMessage: "",
      loading: null,
    };
  },
  components: {
    email,
    Loading,
    PopUp
  },
  methods: {
    resetPassword() {
      this.loading = true;
      firebase
        .auth()
        .sendPasswordResetEmail(this.email)
        .then(() => {
          this.modalMessage =
            "If your accound exists you will receive an email";
          this.loading = false;
          this.modalActive = true;
        })
        .catch((err) => {
          this.modalMessage = err.message;
          this.loading = false;
          this.modalActive = true;
        });
    },
    closeModal() {
      this.modalActive = !this.modalActive;
      this.email = "";
    },
  },
};
</script>

<style lang="scss" scoped>
.reset-password {
  position: relative;

  .form-wrap {
    .reset {
      h2 {
        margin-bottom: 8px;
      }

      p {
        text-align: center;
        margin-bottom: 32px;
      }

      .back-home {
        bottom: 15%;
      }
    }
  }
}
</style>